import {SET_ORDERHIST_SEARCH} from '../constants/ActionTypes'

const initialState = {
    SearchText : '' 
};

export default function orderHist(state = initialState, action) {
    switch (action.type) {
        case SET_ORDERHIST_SEARCH:
            if(state.SearchText !== action.searchText) {
                return Object.assign({}, state, {SearchText: action.searchText});
            }
            return state;
        default:
            return state;
    }
}